// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'

import Vue from 'vue'
import VueRouter from 'vue-router'
import moment from 'moment'
import axios from 'axios'
import Vuelidate from 'vuelidate'
import AMap from 'vue-amap'
import Vddl from 'vddl'
import swal from 'sweetalert2'
import VueLazyLoad from 'vue-lazyload'
import VueTouch from 'vue-touch'
import router from './router'
import store from './store'
import { momentReset, ArcGIS } from '@/utils/reset'
import vueiInfinite from 'vue-infinite-scroll'

import 'normalize.css'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'vue-image-lightbox/dist/vue-image-lightbox.min.css'

import './assets/css/iconfont.css'
import './assets/scss/styles.scss'
import './assets/css/custom.sass'

import {
  Pagination,
  Dialog,
  Input,
  InputNumber,
  Switch,
  Select,
  Option,
  OptionGroup,
  Button,
  ButtonGroup,
  DatePicker,
  Popover,
  Tooltip,
  Form,
  FormItem,
  Tree,
  Tabs,
  TabPane,
  Alert,
  Slider,
  Icon,
  Row,
  Col,
  Loading,
  MessageBox,
  Message,
  Checkbox,
  CheckboxGroup,
  Cascader,
  Collapse,
  CollapseItem,
  Menu,
  MenuItem,
  MenuItemGroup,
  TimePicker,
  breadcrumb,
  breadcrumbItem,
  upload,
  Table,
  TableColumn,
  Autocomplete,
  Radio,
  Dropdown,
  Card
} from 'element-ui'
Vue.use(Card)
Vue.use(vueiInfinite)
Vue.use(Dropdown)
Vue.use(Radio)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Dialog)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Switch)
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Button)
Vue.use(ButtonGroup)
Vue.use(DatePicker)
Vue.use(Popover)
Vue.use(Tooltip)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Tree)
Vue.use(TimePicker)
Vue.use(Alert)
Vue.use(Slider)
Vue.use(Icon)
Vue.use(Row)
Vue.use(Col)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(breadcrumb)
Vue.use(breadcrumbItem)
Vue.use(Loading.directive)
Vue.use(AMap)
Vue.use(Cascader)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(breadcrumb)
Vue.use(breadcrumbItem)
Vue.use(upload)
Vue.use(Autocomplete)

Vue.use(VueLazyLoad)
Vue.use(VueTouch, { name: 'v-touch' })

window._AMapSecurityConfig = {
  securityJsCode: '4878630179c557c9e069d65f7a2d7a7f'
}

AMap.initAMapApiLoader({
  key: 'fc964fbb9cb4fe1c83b2bfe548b39f27',
  // key: 'd80137ed3f1272919f3d03524b75e02f',
  plugin: ['AMap.Autocomplete', 'AMap.PolyEditor', 'AMap.Geolocation', 'AMap.Geocoder', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.ToolBar', 'AMap.CircleEditor']
})

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$message = Message
Vue.prototype.$swal = swal
Vue.use(VueRouter)
Vue.use(Vuelidate)
Vue.use(Vddl)
momentReset(moment)
Object.defineProperty(Vue.prototype, '$moment', { value: moment })
Object.defineProperty(Vue.prototype, '$message', { value: Message })
Object.defineProperty(Vue.prototype, '$axios', { value: axios })
Object.defineProperty(Vue.prototype, '$arcgis', { value: ArcGIS })

Vue.config.productionTip = true

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<router-view/>'
})



// WEBPACK FOOTER //
// ./src/main.js